"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_USER_LANGUAGE = exports.DEFAULT_USER_PASSWORD = exports.DEFAULT_USER_PIN = void 0;
exports.DEFAULT_USER_PIN = '1111';
exports.DEFAULT_USER_PASSWORD = '';
exports.DEFAULT_USER_LANGUAGE = 'en-US';
//# sourceMappingURL=users.js.map